module.exports = __webpack_public_path__ + "377b20ebe2613d9a667928b1b4ad5b1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fedex_3_2023_chart.png
// module id = 1678
// module chunks = 0